import { FC } from "react";

import type { InputEvent } from "@tsmono/inspect-common/types";
import { ANSIDisplay } from "@tsmono/react/components";
import { formatDateTime } from "@tsmono/util";

import { EventPanel } from "./event/EventPanel";
import { EventNode } from "./types";

interface InputEventViewProps {
  eventNode: EventNode<InputEvent>;
  className?: string;
}

export const InputEventView: FC<InputEventViewProps> = ({
  eventNode,
  className,
}) => {
  const event = eventNode.event;
  return (
    <EventPanel
      eventNodeId={eventNode.id}
      title="Input"
      className={className}
      subTitle={
        event.timestamp ? formatDateTime(new Date(event.timestamp)) : undefined
      }
      icon="input"
    >
      <ANSIDisplay
        output={event.input_ansi}
        style={{ fontSize: "clamp(0.4rem, 1.15vw, 0.9rem)" }}
      />
    </EventPanel>
  );
};
